












































































import { Component, Vue } from 'vue-property-decorator';

import { ErrorMessage } from '@/common/errors';
import Fullscreen from '@/layouts/Fullscreen.vue';
import LoginForgotPassword from '@/pages/login/components/LoginForgotPassword.vue';
import LoginInitialPassword from '@/pages/login/components/LoginInitialPassword.vue';
import LoginPageTitle from '@/pages/login/components/LoginPageTitle.vue';
import { UserStore } from '@/store/user';

@Component({
  components: {
    ErrorMessage,
    Fullscreen,
    LoginForgotPassword,
    LoginInitialPassword,
    LoginPageTitle,
  },
})
export default class LoginPage extends Vue {

  @UserStore.Bind.Action logIn!: UserStore.Action<'logIn'>;

  credentials = { username: '', password: '' };
  error = null;
  isSubmitting = false;
  isForgotPasswordShown = false;
  isInitialPasswordShown = false;
  initialPasswordUsername = '';

  async submit() {
    this.isSubmitting = true;
    this.error = null;

    try {
      this.isSubmitting = true;
      await this.logIn(this.credentials);
      this.goHome();
    }
    catch (error) {
      if (error && error.response && error.response.status === 409) {
        this.changeInitialPassword();
      }
      this.error = error;
    }
    finally {
      this.isSubmitting = false;
    }
  }

  goHome() {
    this.$router.push('/');
  }

  changeInitialPassword() {
    // LastPass keeps rewriting the username input value when the modal is
    // shown. This is a dirty workaround...
    this.initialPasswordUsername = this.credentials.username;

    this.isInitialPasswordShown = true;
  }
}
